import { Component, Vue } from 'vue-property-decorator'
import vSelect from 'vue-select'
import SaveModal from './SaveModal/index.vue'
import SubjectOperationalModal from './SubjectOperationalModal/index.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faEdit,
	faLink,
	faBan,
	faScroll,
} from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'

import api from '@/helpers/fetch'
import Fuse from 'fuse.js'

library.add(faTrashAlt, faEdit, faLink, faBan, faScroll)

@Component({
	components: {
		vSelect,
		Loader,
		SaveModal,
		SubjectOperationalModal,
	},
})
export default class CalcSubjects extends Vue {
	loading = false
	allSubjects = [] as Array<any>
	filteredSubjects = [] as Array<any>
	filter = ''
	filterOperational = ''
	modalLoading = false
	savingOpSubject = false

	mounted() {
		this.$store.dispatch('saveCurrentFullPath', this.$route.fullPath)
		this.init()
	}

	async init() {
		this.loading = true
		this.loadOpSubjects()
		this.loadClassification()
		const res = await api.get('/api/calc/subjects')

		this.allSubjects = res.data
		this.filteredSubjects = this.allSubjects
		this.loading = false
	}

	get classifiedSubjects() {
		const result = {}
		this.filteredSubjects.forEach((subject) => {
			const classification = subject.calc_subjects_classification

			const classificationName =
				classification?.name || 'Sem classificação'

			result[classificationName] = result[classificationName] || {}

			const groupingName =
				subject?.calc_subjects_grouping_relations?.[0]
					?.calc_subjects_grouping?.name || 'Outros'

			result[classificationName][groupingName] =
				result[classificationName][groupingName] || []
			result[classificationName][groupingName].push(subject)
		})

		return result
	}

	form: any = {
		id: '',
		name: '',
		status: '',
		desc: '',
		proposal_text: '',
		theme: '',
		trial: '',
		// newOpSubject: '',
		opSubject: '',
		opSubjectsEdit: [] as Array<any>,
		opSubjects: [] as Array<any>,
		outdated: false,
	}

	options = {
		opSubjects: [] as Array<any>,
		classification: [] as Array<any>,
	}

	filterSubjects(list) {
		if (typeof this.filter !== 'string') return
		const searchArray = this.filter?.split(' ')

		const result = list.filter((item) => {
			const name = removeAccents(item.name.toLowerCase())

			return searchArray.every((string) => {
				return name.includes(removeAccents(string.toLowerCase()))
			})
		})

		this.filteredSubjects = result
	}

	onSearchInput() {
		this.filterSubjects(this.allSubjects)
	}

	fuseSearch(options, search) {
		const fuse = new Fuse(options, {
			keys: ['name'],
			shouldSort: true,
			ignoreLocation: true,
		})

		return search.length
			? fuse.search(search).map(({ item }) => item)
			: options
	}

	openEdit(subject) {
		this.form = subject

		this.form.opSubjects = subject.opSubjects || []
		this.form.opSubjectsEdit =
			subject.opSubjects.map((subject) => ({
				id: subject.id,
				name: subject.name,
			})) || []
		this.$bvModal.show('modal-edit')
	}

	openLink(subject) {
		this.form.id = subject.id
		this.form.opSubjects = subject.opSubjects || []
		this.$bvModal.show('modal-link')
	}

	openNew() {
		this.clearForm()
		this.$bvModal.show('modal-new')
	}

	openSubjectOperational() {
		this.$bvModal.show('modal-subject-operational')
	}

	async saveEdit() {
		if (!this.form.name) {
			this.$bvToast.toast("O campo 'nome' é obrigatório!", {
				title: 'Alerta!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'warning',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
			return
		} else {
			this.modalLoading = true

			const res = await api.post(
				'/api/calc/subjects/' + this.form.id,
				this.form,
			)

			if (res.ok) {
				this.loadOpSubjects()
				this.$bvModal.hide('modal-edit')
				this.$bvToast.toast('Edição concluída com sucesso!', {
					title: 'Sucesso!',
					autoHideDelay: 2500,
					appendToast: true,
					variant: 'success',
					toaster: 'b-toaster-top-center',
					solid: true,
				})
			} else {
				this.$bvToast.toast(res.msg, {
					title: 'Erro!',
					autoHideDelay: 5000,
					appendToast: true,
					variant: 'danger',
					solid: true,
				})
			}
		}

		this.modalLoading = false
	}

	async addOpSubject() {
		if (!this.form.opSubject) return
		const opSubject = this.options.opSubjects.find(
			(opSubject) => opSubject.id === this.form.opSubject,
		)

		this.savingOpSubject = true
		const res = await api.post(
			'/api/calc/subjects/' + this.form.id + '/subjects-map',
			{ subject: this.form.opSubject },
		)
		if (res.ok) {
			this.form.opSubjects.push({
				mapId: res.data.id,
				name: opSubject.name,
				id: opSubject.id,
				loading: false,
			})
			this.form.opSubject = ''
		} else {
			this.$bvToast.toast(
				'Não foi possível associar tese, verifique se a tese já não está associada',
				{
					title: 'Erro',
					variant: 'danger',
					solid: true,
					toaster: 'b-toaster-top-center',
				},
			)
		}
		this.savingOpSubject = false
	}

	async removeOpSubject(opSubject, index) {
		opSubject.loading = true
		const res = await api.delete(
			'/api/calc/subjects/' + this.form.id + '/subjects-map',
			{ mapId: opSubject.mapId },
		)
		if (res.ok) {
			this.form.opSubjects.splice(index, 1)
		}
		opSubject.loading = false
	}

	async saveNew() {
		if (!this.form.name) {
			this.$bvToast.toast("O campo 'nome' é obrigatório!", {
				title: 'Alerta!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'warning',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
			return
		} else {
			this.modalLoading = true
			const res = await api.post('/api/calc/subjects/', this.form)

			if (res.ok) {
				this.init()
				this.$bvModal.hide('modal-new')
				this.$bvToast.toast('Inclusão concluída com sucesso!', {
					title: 'Sucesso!',
					autoHideDelay: 2500,
					appendToast: true,
					variant: 'success',
					toaster: 'b-toaster-top-center',
					solid: true,
				})
			} else {
				this.$bvToast.toast(res.msg, {
					title: 'Erro!',
					autoHideDelay: 5000,
					appendToast: true,
					variant: 'danger',
					solid: true,
				})
			}
		}
		this.modalLoading = false
	}

	clearForm() {
		this.form = {
			id: '',
			name: '',
			status: '',
			desc: '',
			proposal_text: '',
			theme: '',
			trial: '',
			opSubject: '',
			opSubjectsEdit: [],
			opSubjects: [],
			outdated: false,
			ativo_calculadora: true,
			ativo_conteudos: true,
			ativo_lamina: true,
			ativo_mapa: true,
			ativo_mapa_gerenciar: true,
		}
		this.modalLoading = false
	}

	async loadOpSubjects() {
		const res = await api.get('/api/subjects')
		this.options.opSubjects.length = 0
		this.options.opSubjects.push(...res.data)
	}

	async loadClassification() {
		const res = await api.get('/api/classification')
		this.options.classification = res.data
	}

	async deleteCalcSubject(subject) {
		const res = await api.delete('/api/calc/subjects/', subject)
		if (res.ok) {
			const subjectIndex = this.options.opSubjects.findIndex(
				(item) => item.id === subject.id,
			)
			if (subjectIndex !== -1) {
				this.options.opSubjects.splice(subjectIndex, 1)
			}
			this.filter = this.filter.length ? '' : this.filter
			this.$bvToast.toast('Tese excluída com sucesso!', {
				title: 'Sucesso!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'success',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		} else {
			this.$bvToast.toast('Ocorreu um erro inesperado!', {
				title: 'Erro!',
				autoHideDelay: 2500,
				appendToast: true,
				variant: 'danger',
				toaster: 'b-toaster-top-center',
				solid: true,
			})
		}
	}
}

function removeAccents(str) {
	return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}
